import { FormattedMessage, useIntl } from 'react-intl'
import FormLicensePlate, { FormValues } from './formLicensePlate'

import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import testidKeys from '../../../app/testidKeys'
import { MoovyButton } from '../../../components'
import usePaymentStep from '../../../hooks/usePaymentStep'
import { MoovyStyle } from '../../../styles/theme'
import AlertNoPayment from './alertNoPayment'

export type StepFillLicensePlateProps = {
  formReference: string
  licensePlate: string
  isButtonDisabled: boolean
  onSubmitLicensePlate: (values: FormValues) => void
}

const StepFillLicensePlate = ({
  formReference,
  licensePlate,
  isButtonDisabled,
  onSubmitLicensePlate,
}: StepFillLicensePlateProps) => {
  const intl = useIntl()
  const [paymentStep] = usePaymentStep()

  const GridAlertNoPayment = () => {
    return (
      <Grid
        container
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <Grid
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 20,
          }}
        >
          <AlertNoPayment licensePlate={licensePlate} />
        </Grid>
      </Grid>
    )
  }

  const GridSearchVehicle = () => {
    return (
      <Grid
        container
        size={{ xs: 12 }}
        direction={'column'}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        rowSpacing={MoovyStyle.rowSpacing}
      >
        <Grid
          size={{ xs: 12, sm: 6 }}
          container
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
          rowSpacing={MoovyStyle.rowSpacing}
        >
          <FormLicensePlate
            formReference={formReference}
            licensePlate={licensePlate}
            onSubmit={onSubmitLicensePlate}
          />
          <MoovyButton
            aria-label={intl.formatMessage({
              id: 'page.webPayment.stepFillLicensePlate.button.find',
            })}
            type="submit"
            form={formReference}
            fullWidth
            color="secondary"
            style={{ height: '56px' }}
            disabled={isButtonDisabled}
            data-testid={testidKeys.STEP_LICENSE_PLATE_SEARCH_BUTTON}
          >
            <FormattedMessage id="page.webPayment.stepFillLicensePlate.button.find" />
          </MoovyButton>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid
      size={12}
      container
      marginTop={MoovyStyle.elementSpacingMobile * 2}
      rowSpacing={MoovyStyle.rowSpacing}
      justifyContent="center"
    >
      <Typography variant="h2">
        <FormattedMessage id="page.webPayment.stepFillLicensePlate.info.pay" />
      </Typography>
      <Typography>
        <FormattedMessage id="page.webPayment.stepFillLicensePlate.info.notPaid" />
      </Typography>
      <Typography>
        <FormattedMessage id="page.webPayment.stepFillLicensePlate.info.licensePlate" />
      </Typography>
      <GridSearchVehicle />
      {paymentStep === 'FILL_LICENSE_PLATE_ERROR' && <GridAlertNoPayment />}
    </Grid>
  )
}

export default StepFillLicensePlate
